import React, { useContext } from 'react'
import { extractData, notify, prefix } from '../../../../utils/index_tagging_tool'
import { api } from '../../../../utils/index'

export function EnableOperation({ context }) {
  const { operationsPossible, checkedRules, dimension, setLoading } =
    useContext(context)

  const enableRule = async (rule) => {
   return api.delete(`${prefix}disabled-rules/`, {data: { rule: rule.id, custom: dimension }})
  }

  const enableRules = async (e) => {
    e.preventDefault()
    setLoading(true)
    const ruleList = JSON.parse(JSON.stringify(checkedRules))
    await Promise.all(
      ruleList.map(async (rule) => {
        // Scorro i selezionati e cancello tutto
        if (rule.id !== -1) {
          try {
            const response = await enableRule(rule)
            extractData(response)
          } catch (e) {
            notify(e.message, 'error')
          }
        }
      })
    )
    window.location.reload()
  }

  return (
    <>
      {operationsPossible.includes('Abilita') && (
        <div className={'operationsDiv'} onClick={enableRules}>
          Riabilita
        </div>
      )}
    </>
  )
}
